import { useEffect, useState } from "react";
import { 
  getVariables, 
  getFormBranchesSlots, 
  getValues, 
  updateValue, 
  deleteValue,
  addValue 
} from "../../services/variables";

export default function useVariable() {
  const [isLoading, setIsLoading] = useState(true);
  const [variables, setVariables] = useState([]);
  const [slotsCandidates, setSlotsCandidates] = useState([]);
  const [values, setValues] = useState([]);

  const fetchData = async () => {
    const [variablesData, candidatesData, valuesData] = await Promise.all([
      getVariables(),
      getFormBranchesSlots(),
      getValues(),
    ]);

    variablesData && setVariables(variablesData);
    candidatesData && setSlotsCandidates(candidatesData);
    valuesData && setValues(valuesData);

    setIsLoading(false);
  };

  useEffect(() => {
    setIsLoading(true);
    fetchData().catch(console.error);
  }, []);

  const reloadTable = async () => {
    setIsLoading(true);
    fetchData().catch(console.error);
  };

  const handleAddSlotValue = async (userId, variableId, newValue) => {
    try {
      const newSlotValue = {
        user_id: userId,
        slot_id: variableId,
        value: newValue,
      };

      const response = await addValue(newSlotValue);
      if (response?.slot_value) {
        const addedSlot = response.slot_value;
        setValues((prevValues) =>
          prevValues.map((userSlots) =>
            userSlots.user_id === userId
              ? {
                  ...userSlots,
                  slots: [...(userSlots.slots || []), addedSlot],
                }
              : userSlots
          )
        );
      }
    } catch (error) {
      console.error("Error adding slot value:", error);
    }
  };

  const handleDeleteSlotValue = async (slotValueId, userId) => {
    try {
      const response = await deleteValue(slotValueId);
      if (response) {
        setValues((prevValues) =>
          prevValues.map((userSlots) =>
            userSlots.user_id === userId
              ? {
                  ...userSlots,
                  slots: (userSlots.slots || []).filter((slot) => slot.id !== slotValueId),
                }
              : userSlots
          )
        );
      }
    } catch (error) {
      console.error("Error deleting slot value:", error);
    }
  };

  const handleEditSlotValue = async (slotValueId, userId, newValue) => {
    try {
      const updatedValue = {
        slot_value_id: slotValueId,
        user_id: userId,
        value: newValue,
      };

      const response = await updateValue(updatedValue);
      if (response?.slot_value) {
        const editedSlot = response.slot_value;
        setValues((prevValues) =>
          prevValues.map((userSlots) =>
            userSlots.user_id === userId
              ? {
                  ...userSlots,
                  slots: (userSlots.slots || []).map((slot) =>
                    slot.id === slotValueId
                      ? {
                          ...slot,
                          ...editedSlot,
                          slot_value: editedSlot.slot_value ?? newValue,
                        }
                      : slot
                  ),
                }
              : userSlots
          )
        );
      }
    } catch (error) {
      console.error("Error updating slot value:", error);
    }
  };

  return {
    isLoading,
    variables,
    reloadTable,
    slotsCandidates,
    values,
    setVariables,
    handleEditSlotValue,
    handleDeleteSlotValue,
    handleAddSlotValue,
  };
}